import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: sergiocarlotto
 * id 3A9176D6-A724-4E82-9F8B-00CEEC8A9D64
 * name share-all
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/share-all.svg
 * tags
 */
export const ShareAllIcon = createSvgIcon(<><path d="M11 9V5L18 12L11 19V14.9C6 14.9 2.5 16.5 0 20C1 15 4 10 11 9M17 8V5L24 12L17 19V16L21 12L17 8Z" /></>, 'ShareAllIcon');
export default ShareAllIcon